//UnAuthorize Page for who try to access pages which are not permmitted
<template>
  <div class="flex justify-center content-center flex-wrap">
    <img
      class="md:pl-6"
      src="../../assets/Images/unAthorized.gif"
      style="height:327px"
    />
  </div>
  <div class="mb-6 text-gray-800 text-center font-sans text-xl">
    <span class="opacity-50">
      <router-link to="/sign-in" class="border-b border-2	cobalt-border-color"
        >Sign Up</router-link
      >
      or
      <router-link to="/login" class="border-b border-2	cobalt-border-color"
        >Login</router-link
      >
      to access page
    </span>
  </div>
</template>

<script>
export default {
  name: "UnAthorized",
};
</script>
